import { render, staticRenderFns } from "./gebruiker-confirmationcode.html?vue&type=template&id=2c10f2a0&scoped=true&"
import script from "./gebruiker-confirmationcode.js?vue&type=script&lang=js&"
export * from "./gebruiker-confirmationcode.js?vue&type=script&lang=js&"
import style0 from "./gebruiker-confirmationcode.css?vue&type=style&index=0&id=2c10f2a0&scoped=true&lang=css&"
import style1 from "@/css/appschoolware.css?vue&type=style&index=1&id=2c10f2a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10f2a0",
  null
  
)

export default component.exports